module.exports = __webpack_public_path__ + "static/media/tr.e0edc2d3.png";